import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// style
import Style from "./ModalApplicationUpdated.module.css";

const ModalApplicationUpdated = (height, width, modalMessage
  
) => {
  const [heightPercentage, setHeightPercentage] = useState("25%");
  const [widthPercentage, setWidthPercentage] = useState("30%");
  const [message, setMessage] = useState("Prijava uspješno ažurirana!");
  const navigate = useNavigate();

  useEffect(() => {
    if (height) {
      setHeightPercentage(height);
    }

    if (width) {
      setWidthPercentage(width);
    }

    if (modalMessage) {
      setMessage(modalMessage);
    }
  }, [height, width, modalMessage]);

  return (
    <div className={Style.ModalContainerOverlay}>
      <div
        className={Style.Modal}
        style={{ height: heightPercentage, width: widthPercentage }}
      >
        <h3 className={Style.ModalQuestion}>{message}</h3>
        <button className={Style.BackButton} onClick={()=>navigate("/FirstInput")}>Natrag</button>
      </div>
    </div>
  );
};

export default ModalApplicationUpdated;
